import React, { useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import BoxInput from '../../Common/BoxInput/BoxInput'
import Lottie from 'lottie-react'
import successLottie from '../../../utils/Lottie/NewSuccess.json';
import IconReusable from '../../../components/IconReusable'
import AuthCardContainer from './AuthCardContent'
import { CustomButton } from '../../../v2/MUI_custom_component';
import { creteEPinAction } from './API/Action';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import HumbeeModal from '../../../v2/MUI_custom_component/Modal/HumbeeModal';
import AnimationModal from '../../../v2/MUI_custom_component/Modal/AnimationModal';
import { useDispatch, useSelector } from 'react-redux';
import { OTP_PURPOSE_ENUM } from '../Enum';
import { onLoggedIn } from '../../../v2/Function/onLoggedIn';
import { encryptPassword } from '../../../v2/Utils/Encryption/NodeForgeEncryption';
import { decodeToken } from '../../../utils/settings';
import { EPIN_REGEX } from './Components/regex';


const CreateEpin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [epin, setEpin] = React.useState('');
  const [confirmEpin, setConfirmEpin] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [epinErr, setEpinErr] = React.useState('');
  const [confirmEpinErr, setConfirmEpinErr] = React.useState('');
  const [apiError, setApiError] = React.useState('');
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [tokenData, setTokenData] = React.useState(null);
  const OTP_PURPOSE = useSelector((state) => state.authReducer.OTP_PURPOSE);
  const mobile_number = useSelector(state => state.authReducer.mobile);
  const VFC_TOKEN = useSelector(state => state.authReducer.VFC_TOKEN);
  const EPIN_SET = useSelector((state) => state.authReducer.EPIN_SET);
  const USER_DATA_FILLED = useSelector(state => state.authReducer.USER_DATA_FILLED);
  
  const handleRedirection = async() => {
      if (!USER_DATA_FILLED) {
        navigate('/user-details');
      } else {
        await onLoggedIn({
            data: {
                token: token
            },
            navigate,
            dispatch,
            toast
        });
      }
      if(OTP_PURPOSE === OTP_PURPOSE_ENUM.RESET) {
        navigate('/login');
      }
  }
  const token = localStorage.getItem('token');
  useEffect(() => {
      const token = localStorage.getItem('token');
      const getTokenData = async () => {
        if (token) {
          const decoded = await decodeToken(token);
          setTokenData(decoded);
        }
      };
      getTokenData();
  }, []);

  const isEPinFormValid = EPIN_REGEX.test(epin) && EPIN_REGEX.test(confirmEpin);

  const handleCreateEpin = async () => {
    let epinErr = '';
    let confirmEpinErr = '';

    if (!epin) epinErr = 'e-Pin is required';
    else if (!/^\d{6}$/.test(epin)) epinErr = 'e-Pin must be 6 digits';

    if (!confirmEpin) confirmEpinErr = 'Confirmation e-Pin is required';
    else if (!/^\d{6}$/.test(confirmEpin)) confirmEpinErr = 'Confirmation e-Pin must be 6 digits';
    else if (epin !== confirmEpin) confirmEpinErr = 'e-Pins do not match';

    setEpinErr(epinErr);
    setConfirmEpinErr(confirmEpinErr);
    if (epinErr || confirmEpinErr) {
      setLoading(false);
      return;
    }

    setLoading(true);
    const encryptedEpin = encryptPassword(epin);
    const encryptedConfirmEpin = encryptPassword(confirmEpin);
    const payload = { 
      mobile_number: mobile_number,
      epin: encryptedEpin,
      c_epin: encryptedConfirmEpin,
      vfc_token: VFC_TOKEN,
      purpose: OTP_PURPOSE,
      user_id: OTP_PURPOSE === OTP_PURPOSE_ENUM.LOGIN ? tokenData?.user_id : null,
    };
    const { data, error, message } = await creteEPinAction(payload);
    setLoading(false);
    if (!error) {
      // if(OTP_PURPOSE === OTP_PURPOSE_ENUM.RESET) {
      //   toast.success(message);
      // }
      if(OTP_PURPOSE === OTP_PURPOSE_ENUM.REGISTER) {
        localStorage.setItem('token', data?.token);
      }
      dispatch({ type: 'SET_EPIN_SET', payload: data?.is_epin_set });
      dispatch({ type: 'SET_USER_DATA_FILLED', payload: data?.user_data_filled });
      setShowSuccess(true);
    } else {
      setApiError(message);
    }
  };
  return (
    <AuthCardContainer>
      <Box sx={{ display:"flex", flexDirection:"column", gap: 4 }}>
        <Typography variant='h1' sx={{ color: '#666666' }}>
            {OTP_PURPOSE === OTP_PURPOSE_ENUM.REGISTER ? 'Register' : OTP_PURPOSE === OTP_PURPOSE_ENUM.RESET ? 'Reset e-Pin to login' : 'Set e-Pin'}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant='h2'>Create e-Pin</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: apiError ? 1 : 0 }}>
            <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
              <BoxInput
                label="Enter e-Pin*"
                length={6}
                value={epin}
                onChange={val => setEpin(val)}
                type="password"
                showEyeIcon={true}
                error={!!epinErr}
              />
              {epinErr && <Typography variant="body2" sx={{ color: '#CC0000', minHeight: 20 }}>{epinErr}</Typography> } 
              <BoxInput
                label="Confirm e-Pin*"
                length={6}
                value={confirmEpin}
                onChange={val => setConfirmEpin(val)}
                type="password"
                showEyeIcon={true}
                error={!!confirmEpinErr}
              />
              {confirmEpinErr && <Typography variant="body2" sx={{ color: '#CC0000', minHeight: 20 }}>{confirmEpinErr}</Typography> } 
            </Box>
            {apiError && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <IconReusable name="ErrorFilled" size={20} color="#CC0000" />
                <Typography variant='body1' sx={{ color: '#CC0000', }}>
                  {apiError}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
        <CustomButton 
          variant='filled'
          disabled={!isEPinFormValid || loading}
          label='Save e-Pin'
          fullWidth
          onClick={handleCreateEpin}
        />
        {showSuccess && (
          <AnimationModal
              maxWidth = {{xs: '500px', md: '610px' }}
              width = {{ xs: '500px', md: '610px' }}
              open={showSuccess}
              onClose={() => setShowSuccess(false)}
              title='Successful! '
              subtitle='e-Pin set successfully.'
              onAnimationComplete={handleRedirection}
              loop={false}
              animationData={successLottie}
            />
        )}
      </Box>
    </AuthCardContainer>
  )
}

export default CreateEpin